export default class HelperService {

  constructor(authService, $translate, apiService, $cookies, $q) {
    'ngInject';

    Object.assign(this, { authService, $translate, apiService, $cookies, $q });

  }

  initIntercom(hideFlag = false) {
    // this.authService.getUser()
    //   .then(data => {
    //     window.Intercom("boot", {
    //       app_id: "xhwiyx1c",
    //       name: data.first_name,
    //       email: data.email,
    //       hide_default_launcher: hideFlag
    //     });
    //   });
  }

  shutdownIntercom(hideFlag = false) {
    window.Intercom("shutdown");
  }

  getCurrentLang() {
    let lang;
    if (angular.isUndefined(this.$cookies.get('lang'))) {
      lang = 'en';
    } else {
      lang = this.$cookies.get('lang');
    }
    return this.$q.resolve(lang);
  }

  changeLanguage(key) {
    this.$cookies.put('lang', key);
    this.$translate.use(key);
  }

  sendEmail(data) {
    return this.apiService.post({
      url: '/api/v1/emails',
      data
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/services/helper.service.js